<div class="contest-detail__wrapper">
    <app-contest-header *ngIf="canCompete"
                        [contest]="contest">
    </app-contest-header>
    <div class="contest-detail__content"
         [ngClass]="{'contest-detail__content--border-radius': !canCompete}">
        <h2 class="contest-detail__title">{{ contest?.name }}</h2>
        <div class="contest-detail__primary-content">
            <div *ngIf="contest?.goals"
                 class="contest-detail__goals">
                <mat-icon svgIcon="sports-score-rounded"></mat-icon>
                <h3>{{ "contest.goals_title" | translate }}</h3>
                <p [innerHTML]="contest?.goals"></p>
            </div>
            <app-contest-timer timerTitle="contest.will_end_in"
                               [targetDate]="contest?.endDate" 
                               alignIcon="right"
                               class="contest-detail__timer">
            </app-contest-timer>
        </div>
        <ng-container>
            <div class="contest-detail__secondary-content">
                <div class="contest-detail__rewards">
                    <h3>Lots à gagner</h3>
                    <div [innerHTML]="contest?.prizes">
                    </div>
                </div>
                <div class="contest-detail__progress-count">{{ progress }}%</div>
                <div class="contest-detail__progress-wrapper">
                    <div class="contest-detail__progress-score">
                        <div>
                            <span>{{ score }}</span>
                            <span class="contest-header__progress-max-score">&nbsp;/&nbsp;{{ contest?.globalProgress['goalPoints'] }} </span>
                        </div>
                        <mat-icon svgIcon="diamond"></mat-icon>
                    </div>
                    <progress class="contest-detail__progress-bar"
                              [value]="progress"
                              max="100"
                              role="progressbar">
                    </progress>
                    <div class="contest-detail__progress-marker"></div>
                    <mat-icon svgIcon="cursor"
                              class="contest-detail__progress-cursor"
                              [ngStyle]="{'left': progress + '%'}">
                    </mat-icon>
                </div>
                <img class="contest-detail__radio-image"
                     src="/assets/amazon_python/images/radio.png"
                     aria-hidden="true">
                <div *ngIf="!canCompete"
                     class="contest-detail__tickets">
                    <div class="contest-detail__tickets-count">
                        <div>{{ tickets }}</div>
                        <div>{{ 'contest.ticket_label' | translate }}</div>
                    </div>
                    <div class="contest-detail__tickets-content">
                        <h3>{{ 'contest.ticket_title' | translate }}</h3>
                        <p>{{ 'contest.ticket_description' | translate }}</p>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #stretchGoalsBlock>
            <div class="contest-detail__secondary-content contest-detail__secondary-content--stretch-goals">
                <div class="contest-detail__congratulations">
                    <h3>Bien joué&nbsp;!</h3>
                    <p>
                        <span>Avec l’aide de tous les participants, vous avez cumulé 100&nbsp;000 </span>
                        <mat-icon svgIcon="diamond"></mat-icon>
                        <span> en réalisant des parcours. Dépassez vos limites et débloquez de nouveaux lots&nbsp;!</span>
                    </p>
                </div>
                <div class="contest-detail__encouragement">
                    <h3>Tu as fini&nbsp;?</h3>
                    <p>Motive tes amis afin de faire avancer le projet et débloquer les nouveaux lots&nbsp;! Les tirages au sort auront lieu le 23/09/23.</p>
                </div>
                <div class="contest-detail__progress-count">{{ progress }}%</div>
                <div class="contest-detail__progress-wrapper">
                    <div class="contest-detail__progress-score">
                        <div>
                            <span>{{ score }}</span>
                            <span class="contest-header__progress-max-score">&nbsp;/&nbsp;200&nbsp;000</span>
                        </div>
                        <mat-icon svgIcon="diamond"></mat-icon>
                    </div>
                    <progress class="contest-detail__progress-bar"
                              [value]="progress - 100"
                              max="100"
                              role="progressbar">
                    </progress>
                    <ng-container *ngFor="let stretchGoal of stretchGoals">
                        <div class="contest-detail__progress-marker"
                             [ngClass]="{'contest-detail__progress-marker--completed': progress >= stretchGoal.progress }"
                             [ngStyle]="{'left': stretchGoal.progress - 100 + '%'}">
                        </div>
                    </ng-container>
                    <mat-icon svgIcon="cursor"
                              class="contest-detail__progress-cursor"
                              [ngStyle]="{'left': progress - 100 + '%'}">
                    </mat-icon>
                </div>
                <img class="contest-detail__radio-image"
                     src="/assets/amazon_python/images/radio.png"
                     aria-hidden="true">
                <div class="contest-detail__stretch-goals">
                    <ng-container *ngFor="let stretchGoal of stretchGoals">
                        <ng-container *ngIf="progress < stretchGoal.progress; else stretchGoalCompletedBlock">
                            <div class="contest-detail__stretch-goal">
                                <div class="contest-detail__stretch-goal-progress">{{ stretchGoal.progress }}&nbsp;%</div>
                                <img class="contest-detail__camera-image"
                                     src="/assets/amazon_python/images/camera.png"
                                     aria-hidden="true">
                                <h3>{{ stretchGoal.title }}</h3>
                                <p>{{ stretchGoal.description }}</p>
                            </div>
                        </ng-container>
                        <ng-template #stretchGoalCompletedBlock>
                            <div class="contest-detail__stretch-goal contest-detail__stretch-goal--completed">
                                <mat-icon svgIcon="check-circle-rounded_fill"
                                          class="contest-detail__achievement-icon">
                                </mat-icon>
                                <img class="contest-detail__camera-image"
                                     src="/assets/amazon_python/images/camera.png"
                                     aria-hidden="true">
                                <h3>{{ stretchGoal.title }}</h3>
                                <p>{{ stretchGoal.description }}</p>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </ng-template>
        <div class="contest-detail__footer">
            <div class="contest-detail__courses-illustration">
                <mat-icon svgIcon="conversion-path"></mat-icon>
                <div>De nouveaux <span>parcours</span></div>
            </div>
            <div class="contest-detail__courses-content">
                <h3>Comment participer&nbsp;?</h3>
                <p>Réalise un maximum d’exercices et aide tes camarades s’ils ont besoin. Plus ta classe réussit d’exercices, plus celles-ci aura des chances de remporter un lot !</p>
            </div>
            <div class="contest-detail__rewards-illustration">
                <mat-icon svgIcon="package"></mat-icon>
                <div>Des <span>récompenses</span> exclusives</div>
            </div>
            <div class="contest-detail__rewards-content">
                <h3>Qu'est-ce que je peux gagner&nbsp;?</h3>
                <p>Tu peux gagner une calculatrice scientifique ou un stylo 4 couleurs exclusif en participant au concours Citizen Code Python !</p>
            </div>
            <div class="contest-detail__ranking-illustration">
                <mat-icon svgIcon="leaderboard"></mat-icon>
                <div>Un <span>classement</span> national</div>
            </div>
            <div class="contest-detail__ranking-content">
                <h3>Qui participe&nbsp;?</h3>
                <p>Des milliers d'élèves partout en France s’affrontent dans ce concours ! Il est ouvert à toutes les classes, quel que soit le niveau :)</p>
            </div>
        </div>
    </div>
</div>